<header class="header-desktop">
  <div class="header-desktop__top">
    <div class="container d-flex gap-3 gap-xl-4 align-items-center justify-content-between">
      <a [routerLink]="''" class="header-desktop__top--logo">
        <cx-abstract [component]="components | cmsComponent: CX_COMPONENT.LOGO" />
      </a>

      <div class="header-desktop__top--searchable">
        <cx-searchable />
      </div>

      <!-- B2B Unit Display -->
      <div class="b2b-unit-display">
        @if (currentB2bUnit$ | async; as currentB2bUnit) {
          <div class="b2b-unit-display__content">
            <div class="b2b-unit-display__info">
              <div class="b2b-unit-display__text">
                <span class="b2b-unit-display__name">{{ currentB2bUnit.name }}</span>
                <span class="b2b-unit-display__code">{{ currentB2bUnit.uid }}</span>
              </div>
            </div>
            <button
              class="b2b-unit-display__search-btn"
              type="button"
              (click)="openB2bUnitSelectionModal()"
              [title]="'header.changeB2BUnit' | translate"
              aria-label="Change B2B Unit"
            >
              <span class="material-symbols-outlined">search</span>
            </button>
          </div>
        } @else {
          <div class="b2b-unit-display__content">
            <div class="b2b-unit-display__info">
              <span class="b2b-unit-display__placeholder">{{ 'header.selectB2BUnit' | translate }}</span>
            </div>
            <button
              class="b2b-unit-display__search-btn"
              type="button"
              (click)="openB2bUnitSelectionModal()"
              [title]="'header.searchB2BUnit' | translate"
              aria-label="Select B2B Unit"
            >
              <span class="material-symbols-outlined">search</span>
            </button>
          </div>
        }
      </div>

      <cx-abstract [component]="components | cmsComponent: CX_COMPONENT.PROFILE_LINKS" />
    </div>
  </div>

  <div class="header-desktop__navigation">
    <div class="container d-flex justify-content-between align-items-center gap-4">
      <cx-abstract [component]="components | cmsComponent: CX_COMPONENT.MAIN_NAVIGATION_BAR" />

      <div class="header-desktop__navigation--nav-end">
        <cx-abstract [component]="components | cmsComponent: CX_COMPONENT.AUXILIARY_LINKS" />

        <mini-cart></mini-cart>
      </div>
    </div>
  </div>
</header>
